import CrudRequest from '@rootCommon/services/crud-request';
import { USER_GROUPS } from '@rootCommon/constants/end-points';
import { ADMIN } from '@rootCommon/constants/common';
import { UserGroup, UserGroupDto } from '@rootCommon/types/user-group';
import { Filters } from '@rootCommon/types/filter';

const USER_GROUPS_ADMIN = `${USER_GROUPS}/${ADMIN}`;

class UserGroupsService extends CrudRequest<UserGroup, UserGroupDto> {
  constructor() {
    super(USER_GROUPS_ADMIN);
  }

  getList = async (filters?: Filters): Promise<UserGroup[]> => {
    let params = {} as Filters;

    if (filters) {
      params = { ...params, ...filters };
    }

    const res = await CrudRequest.get<UserGroup[]>(`${USER_GROUPS}/all/${ADMIN}`, { params });

    return res.data;
  };
}

export default new UserGroupsService();
